import { Context } from "./Reducers/Store";
import React, { useContext } from "react";
import { useLocation, Navigate } from "react-router-dom";
import AlertComponent from "./components/AlertComponent";

function RequireAuth({ children, permissao, permissoes }) {
    const [state, dispatch] = useContext(Context);
    let location = useLocation();

    // Verifica se está logado
    if (!state.isLogged) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Verifica permissão única
    if (permissao) {
        const userPermissoes = state.profile?.permissoes || [];
        if (!userPermissoes.includes(permissao)) {
            AlertComponent("Erro", "Você não tem permissão para acessar esta página.", { icon: "error" });
            return <Navigate to="/dashboard" replace />;
        }
    }

    // Verifica se tem pelo menos uma das permissões
    if (permissoes && permissoes.length > 0) {
        const userPermissoes = state.profile?.permissoes || [];
        const temAlguma = permissoes.some(p => userPermissoes.includes(p));
        if (!temAlguma) {
            AlertComponent("Erro", "Você não tem permissão para acessar esta página.", { icon: "error" });
            return <Navigate to="/dashboard" replace />;
        }
    }

    return children;
}

export default RequireAuth;